import React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import qs from 'query-string';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import CustomRadioButton from '../common/CustomRadioButton';

const RadioWrapperComponent = (props) => {

    const { t } = useTranslation();
    const { filterKey, tableName } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [search, setSearch] = React.useState(() => Object.fromEntries([...searchParams]));
    const [values, setValues] = React.useState(() => {
        const paramValue = searchParams.get(filterKey);
        return paramValue || '';
    });
    const [filter, setFilter] = React.useState(() => props.filter);

    const { [tableName]: { filters } } = useSelector(state => state?.filterSelected);

    useEffect(() => {
        const paramValue = searchParams.get(filterKey);
        setSearch(Object.fromEntries([...searchParams]));
        setValues(paramValue || "");
        setFilter(filter.map(d => ({ ...d, checked: d.value === paramValue })));
    }, [searchParams])

    const handleFilter = ({ item, event }) => {
        let filterPayload;
        const checked = event.target.checked;
        const updatedobject = filter.map(d => ({
            ...d,
            checked: d.value === item.value ? checked : false
        }));

        filterPayload = checked ? item.value : '';

        setFilter(updatedobject);
        setValues(filterPayload);
        setSearchParams(qs.stringify({
            ...search,
            [filterKey]: filterPayload
        }))
    }

    return (
        <FormControl>
            <FormGroup>
                {
                    filters[filterKey]?.data?.map((d, idx) => {
                        return (<FormControlLabel
                            key={idx}
                            control={<CustomRadioButton name={d.value} value={d.value} onChange={(e) => handleFilter({ item: d, event: e })} checked={values === d.value} />}
                            label={<Typography
                                variant='body1'
                                className="lableStyles"
                            >
                                {t(d.name)}
                            </Typography>}
                        />)
                    })
                }
            </FormGroup>
        </FormControl>
    )
}

export default RadioWrapperComponent